import React from 'react';
import HindiDivas2023 from 'views/HindiDivas2023'

const SchoolProgrampage = () => {
  return <HindiDivas2023 />;
};

export default SchoolProgrampage;